var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgVCms05(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 46,
    height: 46,
    viewBox: "0 0 46 46",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_101_1970)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M23.1048 36.0763V44.7379C23.1048 45.0612 22.84 45.3262 22.519 45.3262H19.9622C19.3383 45.3262 19.2644 45.2625 19.1651 44.7761L17.7109 35.8471",
    stroke: "#457ABD",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.0412 11.6656C43.1065 8.22742 41.9911 3.76551 38.5532 1.70261C37.4759 1.05834 36.2994 0.722141 35.1304 0.673715H34.5166C32.1584 0.773082 29.8944 2.01841 28.5905 4.19083C26.9809 6.87509 27.3044 10.1782 29.1583 12.483L29.4436 16.8813L33.4597 15.0629C36.363 15.6155 39.4318 14.3473 41.0412 11.6656Z",
    stroke: "#457ABD",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.6729 7.94229V11.4033C32.6729 11.8389 32.8537 11.9687 33.2662 11.7064L38.7952 8.20211C38.9148 8.12314 38.9759 8.03402 38.9759 7.94229C38.9759 7.85056 38.9148 7.75892 38.7952 7.68255L33.2662 4.17819C32.8537 3.91585 32.6729 4.04325 32.6729 4.48124V7.94229Z",
    stroke: "#457ABD",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.8426 8.76491C3.16432 12.2769 3.78074 16.6089 6.68898 19.5199C9.56677 22.3977 13.8401 23.0293 17.3316 21.4172L22.975 22.446L21.9462 16.8024C23.5582 13.3109 22.9267 9.0374 20.0489 6.15953C16.3588 2.46929 10.3791 2.46929 6.68898 6.15953",
    stroke: "#457ABD",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.1744 9.48558H8.67783C8.38494 9.48558 8.14551 9.72502 8.14551 10.0178V16.2243C8.14551 16.5197 8.38494 16.7592 8.67783 16.7592H18.1744C18.4698 16.7592 18.7092 16.5197 18.7092 16.2243V10.0178C18.7092 9.72502 18.4698 9.48558 18.1744 9.48558Z",
    stroke: "#457ABD",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.33154 9.61552L13.4275 13.484L18.5208 9.61552",
    stroke: "#457ABD",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.0532 28.762H38.6729C39.5643 28.762 40.2926 29.4904 40.2926 30.3817V32.9438C40.2926 33.8351 39.5643 34.5635 38.6729 34.5635H37.0532V28.762Z",
    stroke: "#457ABD",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.105 39.601H25.3435C26.0948 39.601 26.7111 38.9846 26.7111 38.2308V36.7995",
    stroke: "#457ABD",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.8174 35.847V26.2941",
    stroke: "#457ABD",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.8384 32.8674V39.6571M32.8384 22.5429V29.7552",
    stroke: "#457ABD",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.0533 31.0719V21.491C37.0533 20.3476 37.0686 19.5351 35.836 20.4647C30.3275 24.6133 25.9752 26.2942 19.0686 26.2942H16.9191C14.291 26.2942 12.1416 28.4437 12.1416 31.0719C12.1416 33.6977 14.291 35.8471 16.9191 35.8471H19.0686C25.9752 35.8471 30.3275 37.5279 35.836 41.6792C37.0686 42.6063 37.0533 41.7963 37.0533 40.6529V31.0719Z",
    stroke: "#457ABD",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_101_1970"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 46,
    height: 46,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgVCms05);
export default __webpack_public_path__ + "static/media/vCMS05.9a4b3606358ad19e6f0c29a7b26f28cc.svg";
export { ForwardRef as ReactComponent };